import React, { Component } from 'react';

import CamdetectParkinglocationsModel from './CamdetectParkinglocationsModel';

import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon } from 'antd';
import { withState } from 'recompose';
const FormItem = Form.Item;
const { Option } = Select;

class CamdetectCamerasSettingsForm extends Component {

  state = {
    modalVisible: false,
    confirmDirty: false,
    coreParkingLocationID: null,
  }

  form = null;



  componentWillReceiveProps(nextProps) {
    if (nextProps.initialValues != null) {
      CamdetectParkinglocationsModel.get(nextProps.initialValues.parkingLocationID).then(location => {
        this.setState({ coreParkingLocationID: location.coreParkingLocationID })
      })
    }
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        values.coreParkingLocationID = this.state.coreParkingLocationID;
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback('Hesla si musí odpovídat!');
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirmPassword'], { force: true });
    }
    callback();
  };

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 11 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 22,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Název kamery">
          {getFieldDecorator('cameraName', {
            initialValue: this.props.initialValues && this.props.initialValues.cameraName
              ? this.props.initialValues.cameraName
              : null,
            rules: [{
              type: 'string', message: 'Položka musí být string!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Popis">
          {getFieldDecorator('description', {
            initialValue: this.props.initialValues && this.props.initialValues.description
              ? this.props.initialValues.description
              : '',
            rules: [{
              type: 'string', message: 'Položka musí být string!',
            }],
          })(
            <Input.TextArea
              autosize={{
                maxRows: 7
              }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Interval zpráv [min]">
          {getFieldDecorator('messageInterval', {
            initialValue: this.props.initialValues && this.props.initialValues.messageInterval
              ? this.props.initialValues.messageInterval
              : null,
            rules: [{
              type: 'number', message: 'Položka musí být number!',
            }],
          })(
            <InputNumber min={1} max={99} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Počítat invalidy do TotalOcc parkoviště" >
          {getFieldDecorator('countDisabledToTotal', {
            valuePropName: 'checked',
            initialValue: this.props.initialValues && this.props.initialValues.countDisabledToTotal
              ? this.props.initialValues.countDisabledToTotal
              : false,
          })(
            <Switch
              checkedChildren={<Icon type="check" />}
              unCheckedChildren={<Icon type="close" />} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Upozornění">
          {getFieldDecorator('reportsEnabled', {
            valuePropName: 'checked',
            initialValue: this.props.initialValues && this.props.initialValues.reportsEnabled
              ? this.props.initialValues.reportsEnabled
              : false,
          })(
            <Switch
              checkedChildren={<Icon type="check" />}
              unCheckedChildren={<Icon type="close" />} />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={700}
          title="Nastavení kamery"
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
        >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedCamdetectCameraSettingsForm = Form.create()(CamdetectCamerasSettingsForm);

export default WrappedCamdetectCameraSettingsForm;


// WEBPACK FOOTER //
// ./src/components/CamdetectCamerasSettingForm.js